import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetIsStaff, GetIsStaffResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetIsStaffResponse, GetIsStaffResponse>) => response?.data?.isStaff;

const getError = (response?: SWRResponse<GetIsStaffResponse, GetIsStaffResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetIsStaffResponse, GetIsStaffResponse>) => ({
    isStaff: response?.data?.isStaff,
    registered: response?.data?.registered
});

export const usePersonnelsDetails = (firstName?: string, lastName?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!firstName || !lastName) {
            return undefined;
        }
        
        return () => {
            return new GetIsStaff({firstName, lastName});
        };
    }, [firstName, lastName])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default usePersonnelsDetails;
